$(document).ready(function(){
  /*********************** special Popup ***********************/
  $(".fs_special_model_overlay, .fs_special_close").click(function(){
    $("body").removeClass("fs_special_sec");
    $(".fs_special_model_overlay, .fs_special_main").fadeOut();
  });

  $(".fs_special_btn").click(function(){
    setTimeout(function(){ 
      $("body").addClass("fs_special_sec");
      $(".fs_special_model_overlay, .fs_special_main").fadeIn();
    }, 1000);
  });
  
  $("#fs_scroll_trophy_btn").on("click",function(e){
    e.preventDefault();
    $([document.documentElement, document.body]).animate({
      scrollTop: $("#fs_scroll_trophy").offset().top-200
    }, 1000);
  });
  $("#fs_scroll_drafts_btn").on("click",function(e){
    e.preventDefault();
    $([document.documentElement, document.body]).animate({
      scrollTop: $("#fs_scroll_drafts").offset().top-200
    }, 1000);
  });


  $("#fs_scroll_loser_btn").on("click",function(e){
    e.preventDefault();
    $([document.documentElement, document.body]).animate({
      scrollTop: $("#fs_scroll_loser").offset().top-200
    }, 1000);
  });
  
  $("#fs_scroll_belt_btn").on("click",function(e){
    e.preventDefault();
    $([document.documentElement, document.body]).animate({
      scrollTop: $("#fs_scroll_belt").offset().top-200
    }, 1000);
  });
  $("#fs_scroll_rings_btn").on("click",function(e){
    e.preventDefault();
    $([document.documentElement, document.body]).animate({
      scrollTop: $("#fs_scroll_rings").offset().top-200
    }, 1000);
  });

  $('.tr-sinpro-rating-inn').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true
  });
  $('.fs-trp-cst-flt-block li').click(function(){
    var getimg = $(this).text();
    $(this).parent('.fs-trp-cst-flt-block').children('li').removeClass('trp-cst-active');
    $(this).addClass('trp-cst-active');
    if(getimg == 'Customizable') {
      $('.all').hide();
      $('.salenn').hide();
      $('.customize').show();
      $('.sport').hide();
      $('.social').hide();
      $('.footbll').hide();
      $('.achiev').hide();
      $('.trp-inn-fst-bann').hide();
      $('.trp-cust-thrd-row').hide();
      //
      $('.bs_flt_footbll').hide();
      $('.bs_flt_basebll').hide();
      $('.bs_flt_soccer').hide();
      $('.bs_flt_toppers_plaques').hide();
    }else if(getimg == 'Sales') {
      $('.all').hide();
      $('.salenn').show();
      $('.customize').hide();
      $('.sport').hide();
      $('.social').hide();
      $('.footbll').hide();
      $('.achiev').hide();
      $('.trp-inn-fst-bann').hide();
      $('.trp-cust-thrd-row').hide();
      //
      $('.bs_flt_footbll').hide();
      $('.bs_flt_basebll').hide();
      $('.bs_flt_soccer').hide();
      $('.bs_flt_toppers_plaques').hide();
    }else if(getimg == 'Sports') {
      $('.all').hide();
      $('.salenn').hide();
      $('.customize').hide();
      $('.sport').show();
      $('.social').hide();
      $('.footbll').hide();
      $('.achiev').hide();
      $('.trp-inn-fst-bann').hide();
      $('.trp-cust-thrd-row').hide();
      //
      $('.bs_flt_footbll').hide();
      $('.bs_flt_basebll').hide();
      $('.bs_flt_soccer').hide();
      $('.bs_flt_toppers_plaques').hide();
    }else if(getimg == 'Social') {
      $('.all').hide();
      $('.salenn').hide();
      $('.customize').hide();
      $('.sport').hide();
      $('.social').show();
      $('.footbll').hide();
      $('.achiev').hide();
      $('.trp-inn-fst-bann').hide();
      $('.trp-cust-thrd-row').hide();
      //
      $('.bs_flt_footbll').hide();
      $('.bs_flt_basebll').hide();
      $('.bs_flt_soccer').hide();
      $('.bs_flt_toppers_plaques').hide();
    }else if(getimg == 'Fantasy Football') {
      $('.all').hide();
      $('.salenn').hide();
      $('.customize').hide();
      $('.sport').hide();
      $('.social').hide();
      $('.footbll').show();
      $('.achiev').hide();
      $('.trp-inn-fst-bann').hide();
      $('.trp-cust-thrd-row').hide();
      //
      $('.bs_flt_footbll').hide();
      $('.bs_flt_basebll').hide();
      $('.bs_flt_soccer').hide();
      $('.bs_flt_toppers_plaques').hide();
    }else if(getimg == 'Other Achievement') {
      $('.all').hide();
      $('.salenn').hide();
      $('.customize').hide();
      $('.sport').hide();
      $('.social').hide();
      $('.footbll').hide();
      $('.achiev').show();
      $('.trp-inn-fst-bann').hide();
      $('.trp-cust-thrd-row').hide();
      //
      $('.bs_flt_footbll').hide();
      $('.bs_flt_basebll').hide();
      $('.bs_flt_soccer').hide();
      $('.bs_flt_toppers_plaques').hide();
    }else if(getimg == 'All') {
      $('.all').show();
      $('.salenn').hide();
      $('.customize').hide();
      $('.sport').hide();
      $('.social').hide();
      $('.footbll').hide();
      $('.achiev').hide();
      $('.trp-inn-fst-bann').show();
      $('.trp-cust-thrd-row').show();
      //
      $('.bs_flt_footbll').hide();
      $('.bs_flt_basebll').hide();
      $('.bs_flt_soccer').hide();
      $('.bs_flt_toppers_plaques').hide();
    }else if(getimg == 'Football') {
      $('.all').hide();
      $('.salenn').hide();
      $('.customize').hide();
      $('.sport').hide();
      $('.social').hide();
      $('.footbll').hide();
      $('.achiev').hide();
      $('.trp-inn-fst-bann').hide();
      $('.trp-cust-thrd-row').hide();
      //
      $('.bs_flt_footbll').show();
      $('.bs_flt_basebll').hide();
      $('.bs_flt_soccer').hide();
      $('.bs_flt_toppers_plaques').hide();
    }else if(getimg == 'BaseBall') {
      $('.all').hide();
      $('.salenn').hide();
      $('.customize').hide();
      $('.sport').hide();
      $('.social').hide();
      $('.footbll').hide();
      $('.achiev').hide();
      $('.trp-inn-fst-bann').hide();
      $('.trp-cust-thrd-row').hide();
      //
      $('.bs_flt_footbll').hide();
      $('.bs_flt_basebll').show();
      $('.bs_flt_soccer').hide();
      $('.bs_flt_toppers_plaques').hide();
    }else if(getimg == 'Soccer') {
      $('.all').hide();
      $('.salenn').hide();
      $('.customize').hide();
      $('.sport').hide();
      $('.social').hide();
      $('.footbll').hide();
      $('.achiev').hide();
      $('.trp-inn-fst-bann').hide();
      $('.trp-cust-thrd-row').hide();
      //
      $('.bs_flt_footbll').hide();
      $('.bs_flt_basebll').hide();
      $('.bs_flt_soccer').show();
      $('.bs_flt_toppers_plaques').hide();
    }else if(getimg == 'Toppers/Plaques') {
      $('.all').hide();
      $('.salenn').hide();
      $('.customize').hide();
      $('.sport').hide();
      $('.social').hide();
      $('.footbll').hide();
      $('.achiev').hide();
      $('.trp-inn-fst-bann').hide();
      $('.trp-cust-thrd-row').hide();
      //
      $('.bs_flt_footbll').hide();
      $('.bs_flt_basebll').hide();
      $('.bs_flt_soccer').hide();
      $('.bs_flt_toppers_plaques').show();
    }
    
  });

  $('.fs-wall-plques-flt-block li').click(function(){
    $(this).parent('.fs-wall-plques-flt-block').children('li').removeClass('trp-cst-active');
    $(this).addClass('trp-cst-active');
    //var getimg = $(this).text();
    var getimg = $.trim($(this).text());
    if(getimg == 'All') {
      $('.fs-wall-plaques-wp').show();
      $('.fs-wall-plaques-MLB').show();
      $('.fs-wall-plaques-NFLPA').show();
      $('.fs-wall-plaques-Trading').show();
      $('.fs-wall-plaques-Mappable').show();
      $('.fs-wall-plaques-Motivational').show();
      $('.fs-wall-plaques-Nature').show();
      $('.fs-wall-plaques-Culture').show();
      $('.fs-wall-plaques-Memes').show();
      $('.fs-wall-plaques-fan-foot').show(); 
      var getMeTo = document.getElementById("fs-wall-plaques-rel-products-id");
      getMeTo.scrollIntoView({behavior: 'smooth'}, true);
    }else if(getimg == 'Wall Plaques') {
      $('.fs-wall-plaques-wp').show();
      $('.fs-wall-plaques-MLB').hide();
      $('.fs-wall-plaques-NFLPA').hide();
      $('.fs-wall-plaques-Trading').hide();
      $('.fs-wall-plaques-Mappable').hide();
      $('.fs-wall-plaques-Memes').hide();
      $('.fs-wall-plaques-Motivational').hide();
      $('.fs-wall-plaques-Nature').hide();
      $('.fs-wall-plaques-Culture').hide();
      $('.fs-wall-plaques-fan-foot').hide();
      var getMeTo = document.getElementById("fs-wall-plaques-wp-id");
      getMeTo.scrollIntoView({behavior: 'smooth'}, true);
    }else if(getimg == 'MLB Officially Licensed') {
      $('.fs-wall-plaques-wp').hide();
      $('.fs-wall-plaques-MLB').show();
      $('.fs-wall-plaques-NFLPA').hide();
      $('.fs-wall-plaques-Trading').hide();
      $('.fs-wall-plaques-Mappable').hide();
      $('.fs-wall-plaques-Memes').hide();
       $('.fs-wall-plaques-Motivational').hide();
      $('.fs-wall-plaques-Nature').hide();
      $('.fs-wall-plaques-Culture').hide();
      $('.fs-wall-plaques-fan-foot').hide();
      var getMeTo = document.getElementById("fs-wall-plaques-MLB-id");
      getMeTo.scrollIntoView({behavior: 'smooth'}, true);
    }else if(getimg == 'NFLPA Officially Licensed') {
      $('.fs-wall-plaques-wp').hide();
      $('.fs-wall-plaques-MLB').hide();
      $('.fs-wall-plaques-NFLPA').show();
      $('.fs-wall-plaques-Trading').hide();
      $('.fs-wall-plaques-Mappable').hide();
      $('.fs-wall-plaques-Motivational').hide();
      $('.fs-wall-plaques-Nature').hide();
      $('.fs-wall-plaques-Culture').hide();
      $('.fs-wall-plaques-Memes').hide();
      $('.fs-wall-plaques-fan-foot').hide();
      var getMeTo = document.getElementById("fs-wall-plaques-MLB-id");
      getMeTo.scrollIntoView({behavior: 'smooth'}, true);
    }else if(getimg == 'Jumbo Trading Cards') {
      $('.fs-wall-plaques-wp').hide();
      $('.fs-wall-plaques-MLB').hide();
      $('.fs-wall-plaques-NFLPA').hide();
      $('.fs-wall-plaques-Trading').show();
      $('.fs-wall-plaques-Mappable').hide();
      $('.fs-wall-plaques-Memes').hide();
       $('.fs-wall-plaques-Motivational').hide();
      $('.fs-wall-plaques-Nature').hide();
      $('.fs-wall-plaques-Culture').hide();
      $('.fs-wall-plaques-fan-foot').hide();
      var getMeTo = document.getElementById("fs-wall-plaques-Trading-id");
      getMeTo.scrollIntoView({behavior: 'smooth'}, true);
    }else if(getimg == 'Mappable Moments') {
      $('.fs-wall-plaques-wp').hide();
      $('.fs-wall-plaques-MLB').hide();
      $('.fs-wall-plaques-NFLPA').hide();
      $('.fs-wall-plaques-Trading').hide();
      $('.fs-wall-plaques-Mappable').show();
      $('.fs-wall-plaques-Memes').hide();
      $('.fs-wall-plaques-Motivational').hide();
      $('.fs-wall-plaques-Nature').hide();
      $('.fs-wall-plaques-Culture').hide();
      $('.fs-wall-plaques-fan-foot').hide();
      var getMeTo = document.getElementById("fs-wall-plaques-Mappable-id");
      getMeTo.scrollIntoView({behavior: 'smooth'}, true);
    }else if(getimg == 'Memes') {
      $('.fs-wall-plaques-wp').hide();
      $('.fs-wall-plaques-MLB').hide();
      $('.fs-wall-plaques-NFLPA').hide();
      $('.fs-wall-plaques-Trading').hide();
      $('.fs-wall-plaques-Mappable').hide();
      $('.fs-wall-plaques-Memes').show();
      $('.fs-wall-plaques-Motivational').hide();
      $('.fs-wall-plaques-Nature').hide();
      $('.fs-wall-plaques-Culture').hide();
      $('.fs-wall-plaques-fan-foot').hide();
      var getMeTo = document.getElementById("fs-wall-plaques-Memes-id");
      getMeTo.scrollIntoView({behavior: 'smooth'}, true);
    }else if(getimg == 'Fantasy Football') {
      $('.fs-wall-plaques-wp').hide();
      $('.fs-wall-plaques-MLB').hide();
      $('.fs-wall-plaques-NFLPA').hide();
      $('.fs-wall-plaques-Trading').hide();
      $('.fs-wall-plaques-Mappable').hide();
      $('.fs-wall-plaques-Motivational').hide();
      $('.fs-wall-plaques-Nature').hide();
      $('.fs-wall-plaques-Culture').hide();
      $('.fs-wall-plaques-Memes').hide();
      $('.fs-wall-plaques-fan-foot').show();
      var getMeTo = document.getElementById("fs-wall-plaques-fan-foot-id");
      getMeTo.scrollIntoView({behavior: 'smooth'}, true);
    }else if(getimg == 'Motivational') {
      $('.fs-wall-plaques-wp').hide();
      $('.fs-wall-plaques-MLB').hide();
      $('.fs-wall-plaques-NFLPA').hide();
      $('.fs-wall-plaques-Trading').hide();
      $('.fs-wall-plaques-Mappable').hide();
      $('.fs-wall-plaques-Memes').hide();
      $('.fs-wall-plaques-Motivational').show();
      $('.fs-wall-plaques-Nature').hide();
      $('.fs-wall-plaques-Culture').hide();
      $('.fs-wall-plaques-fan-foot').hide();
      var getMeTo = document.getElementById("fs-wall-plaques-Motivational-id");
      getMeTo.scrollIntoView({behavior: 'smooth'}, true);
    }else if(getimg == 'Nature') {
      $('.fs-wall-plaques-wp').hide();
      $('.fs-wall-plaques-MLB').hide();
      $('.fs-wall-plaques-NFLPA').hide();
      $('.fs-wall-plaques-Trading').hide();
      $('.fs-wall-plaques-Mappable').hide();
      $('.fs-wall-plaques-Memes').hide();
      $('.fs-wall-plaques-Motivational').hide();
      $('.fs-wall-plaques-Nature').show();
      $('.fs-wall-plaques-Culture').hide();
      $('.fs-wall-plaques-fan-foot').hide();
      var getMeTo = document.getElementById("fs-wall-plaques-Nature-id");
      getMeTo.scrollIntoView({behavior: 'smooth'}, true);
    }else if(getimg == 'Pop Culture') {
      $('.fs-wall-plaques-wp').hide();
      $('.fs-wall-plaques-MLB').hide();
      $('.fs-wall-plaques-NFLPA').hide();
      $('.fs-wall-plaques-Trading').hide();
      $('.fs-wall-plaques-Mappable').hide();
      $('.fs-wall-plaques-Memes').hide();
      $('.fs-wall-plaques-Motivational').hide();
      $('.fs-wall-plaques-Nature').hide();
      $('.fs-wall-plaques-Culture').show();
      $('.fs-wall-plaques-fan-foot').hide();
      var getMeTo = document.getElementById("fs-wall-plaques-Culture-id");
      getMeTo.scrollIntoView({behavior: 'smooth'}, true);
    }
    
  });
});
